module.exports = __webpack_public_path__ + "img/ada53dd.png";